import { render, staticRenderFns } from "./basic_info_expander.vue?vue&type=template&id=a872a89a&"
import script from "./basic_info_expander.vue?vue&type=script&lang=js&"
export * from "./basic_info_expander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports